// export const url='https://192.168.1.227:3011'

// export const url='https://apinextgen.opentech4u.co.in:3011'
// export const url = "http://192.168.1.238:3000"
// export const url = "http://192.168.1.239:3000"
// export const url = "http://202.21.38.178:3012"

// export const url = "http://192.168.1.33:3014" //Local

export const url = "https://adminbk.ssvws.in" // UAT

// export const url = "http://192.168.1.41:3014" //Local Subham
// export const url = "https://ssvwsoci.synergicapi.in" // For Demo Purpose Only
